<template>
    <v-app id="forgot-password">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-12 rounded">
                            <v-img src="@/assets/img/login-header.png"></v-img>
                            <div class="mt-4 ml-4">
                                <router-link to="/login" class="link-back-to-login"> <v-icon dense> mdi-chevron-left </v-icon> Back to Login</router-link>
                            </div>
                            <v-card-title class="label-forgot-password-title px-6 pt-4 pb-2">Forgot Password</v-card-title>
                            <v-card-text class="px-6">
                                <v-form class="form-data" ref="formData" @submit.prevent="onSubmit()">
                                    <v-alert v-if="!formData.loading && !errors.email && formData.error" type="error" dense outlined>{{ formData.error }}</v-alert>
                                    <!-- Sample FE validation attribute for future purposes -->
                                    <p class="label-forgot-password-description">Provide your account's email for which you want to reset your password</p>
                                    <label for="email" class="field-label font-weight-medium">Email Address</label>
                                    <v-text-field
                                        type="text"
                                        v-model="formData.email"
                                        :class="['mt-1', { 'is-invalid': errors.email }]"
                                        :error-messages="errors.email"
                                        name="email"
                                        placeholder="Enter email address"
                                        solo
                                        dense
                                        required
                                    ></v-text-field>
                                    <v-btn type="submit" block class="btn-login mt-4" :loading="formData.loading" color="primary">Reset password</v-btn>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'forgotPassword',
    data() {
        return {
            formData: {
                loading: false,
                error: '',
                email: '',
                password: ''
            }
        };
    },
    methods: {
        onSubmit() {
            let formStatus = this.$refs.formData.validate();
            if (formStatus && !this.formData.loading) {
                this.formData.loading = true;
                this.$store
                    .dispatch('authentication/forgotPassword', { data: { email: this.formData.email } })
                    .then(() => {
                        this.$cookies.set('countDownPassword', 180);
                        this.$cookies.set('emailForgotPassword', this.formData.email);
                        this.$cookies.set('otpStatus', 'success');
                        this.formData.loading = false;
                        this.$router.push('/password-reset');
                    })
                    .catch((error) => {
                        this.formData.loading = false;
                        this.formData.error = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message || 'Login Error';
                    });
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#forgot-password {
    .label-forgot-password-title {
        color: #16192c;
        font-weight: bold;
    }

    .label-forgot-password-description {
        color: #425466;
        font-weight: 500;
    }

    .link-back-to-login {
        color: #425466;
        cursor: pointer;
        text-decoration: none;
        font-weight: 500;
        opacity: 0.6;
    }

    // .v-text-field {
    //     &.theme--light {
    //         .v-input__slot {
    //             background-color: var(--v-secondaryBackgroundColor-base);
    //         }
    //     }

    //     &.theme--dark {
    //         .v-input__slot {
    //             background-color: var(--v-secondaryBackgroundColor-base);
    //         }
    //     }
    // }
}
</style>
